import { CulturalActivity } from "@common/ADAPT.Common.Model/organisation/cultural-activity";
import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";

export class CulturalActivitySupplementaryData extends BaseEntity<CulturalActivitySupplementaryData> {
    public culturalActivityId!: number;
    public comment?: string;

    public culturalActivity!: CulturalActivity;
}

export const CulturalActivitySupplementaryDataBreezeModel = new BreezeModelBuilder("CulturalActivitySupplementaryData", CulturalActivitySupplementaryData)
    .hasSource()
    .withPluralName("CulturalActivitySupplementaryData")
    .isOrganisationEntity()
    .build();
